import Cookies from 'js-cookie';
const OPTANON_CONSENT_COOKIE = 'OptanonConsent';
const getConsentCookieValue = () => {
    return Cookies.get(OPTANON_CONSENT_COOKIE);
};
const checkCategories = (pattern) => {
    const optanonConsentValue = getConsentCookieValue();
    if (!optanonConsentValue)
        return false;
    const found = optanonConsentValue.match(`${pattern}:1`);
    return found === null;
};
export const isPerformanceCookiesBlocked = () => {
    return checkCategories('C0002');
};
export const isFunctionalCookiesBlocked = () => {
    return checkCategories('C0003');
};
export const isTargetingCookiesBlocked = () => {
    return checkCategories('C0004');
};
export const isSocialMediaCookiesBlocked = () => {
    return checkCategories('C0005');
};
